import ajax from 'utils/request';

// 获取sdk列表
export function getMySDK() {
    return ajax('GET', '/accounts/my/sdklist');
}



// WEBPACK FOOTER //
// ./src/actions/sdk.js